import styled from "@emotion/styled";
import { Instant } from "@js-joda/core";
import React from "react";
import useCountdown from "../../hooks/useCoundown";

interface CountdownProps {
  text: string;
  pendingConfirmationUntil: Instant;
  onTimerEnd: () => void;
}

export function VisitPendingConfirmationCountdown({
  text,
  pendingConfirmationUntil,
  onTimerEnd,
}: CountdownProps) {
  const countdown = useCountdown(onTimerEnd, pendingConfirmationUntil);
  const [textBefore, textAfter] = text.split("%countdown%");

  return (
    <CountdownContainer>
      <Text>
        {textBefore}
        <BannerCountdown>{countdown}</BannerCountdown>
        {textAfter}
      </Text>
    </CountdownContainer>
  );
}

const CountdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const BannerCountdown = styled.span`
  font-weight: 800;
`;

const Text = styled.p`
  margin: 0;
`;
